import APIManagerRemoteApi, { APIPolicyBody } from '../../../../remote-api/APIManagerRemoteApi'
import { LogPointsRuntimeHelper, RuntimeMajor, RuntimeSupport } from './LogPointsRuntimeHelper'
import {
    APIDetail,
    APIPolicy,
    APIPolicyConfiguration,
    ExchangeTemplatePolicy
} from '../../../../remote-api/models'
import { addDataWeaveExpressions } from './MessageLoggingDWExpressions'
import { getFeatureFlag } from '../../../../util/flags'
import { isFlex } from '../../../../util/flex'

export class LogPointsFlexGatewayHelper extends LogPointsRuntimeHelper {

    private static readonly POLICY_VERSION_ID = getFeatureFlag('logPoints.apis.splitMessageLoggingVersion') || '1.0.0'

    private readonly remoteAPI: APIManagerRemoteApi

    constructor(remoteAPI: APIManagerRemoteApi) {
        super(RuntimeMajor.MULE_ONE)

        this.remoteAPI = remoteAPI
    }

    async fetchMessageLoggingPolicy(orgId: string, envId: string, apiId: string): Promise<APIPolicy | undefined> {
        const policies = await this.remoteAPI.fetchAPIPolicies(orgId, envId, apiId)
        const policyFinder = (policy: APIPolicy) => policy.assetId === LogPointsRuntimeHelper.POLICY_ID

        return policies.find(policyFinder)
    }

    async getAPIPolicyBody(api: APIDetail, configuration: APIPolicyConfiguration, policy?: APIPolicy): Promise<APIPolicyBody> {
        const mappedConfigs = addDataWeaveExpressions(configuration, this.runtime)

        const {
            id,
            groupId,
            assetId,
            assetVersion,
            policyTemplateId
        } = LogPointsFlexGatewayHelper.getExtraAPIPolicyBodyValues(policy)

        return {
            apiId: Number(api.id),
            apiVersionId: Number(api.id),
            configurationData: {loggingConfiguration: mappedConfigs},
            pointcutData: null,
            id,
            groupId,
            assetId,
            assetVersion,
            policyTemplateId
        }
    }

    canHandle(api: APIDetail): boolean {
        return isFlex(api)
    }

    protected async fetchMinMuleVersion(orgId: string): Promise<string | undefined> {
        return Promise.resolve('1.0.0')
    }

    protected getDefaultRuntimeSupport(): RuntimeSupport {
        return {minMuleVersion: {major: 1, minor: 0, patch: 0}}
    }

    private static getExtraAPIPolicyBodyValues(policy?: APIPolicy) {
        const id = policy ? policy.id : null
        let groupId = policy && policy.groupId
        let assetId = policy && policy.assetId
        let assetVersion = policy && policy.assetVersion
        let policyTemplateId = policy && policy.policyTemplateId ? policy.policyTemplateId : undefined

        if (!policy) {
            groupId = LogPointsRuntimeHelper.GROUP_ID
            assetId = LogPointsRuntimeHelper.POLICY_ID
            assetVersion = LogPointsFlexGatewayHelper.POLICY_VERSION_ID
        }

        return {id, groupId, assetId, assetVersion, policyTemplateId}
    }
}
